import { render, staticRenderFns } from "./SystemLogBox.vue?vue&type=template&id=12898623&scoped=true&"
import script from "./SystemLogBox.vue?vue&type=script&lang=js&"
export * from "./SystemLogBox.vue?vue&type=script&lang=js&"
import style0 from "./SystemLogBox.vue?vue&type=style&index=0&id=12898623&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12898623",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VContainer,VIcon,VRow})
